var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsDateString, IsEnum, IsIn, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Matches, Max, Min, ValidateNested, } from "class-validator";
import { APIClientDTO, CreateAPIClientDTO, CreatedAPIClientDTO, UpdateAPIClientAccessDTO, } from "./api/rpc/api-client.dto";
import { BenefitTypeDTO } from "./api/rpc/benefit-type.dto";
import { BonusTypeDTO } from "./api/rpc/bonus-type.dto";
import { CreateNewCurrentContractParams } from "./api/rpc/contract.dto";
import { ConversationUsageDTO } from "./api/rpc/conversation-usage.dto";
import { CostsByVenueDTO, CostsForEmployeeDTO, CostStructureDTO, GetCostsByVenueDTO, GetCostsForEmployeeDTO, GetCostStructureDTO, } from "./api/rpc/cost-structure.dto";
import { DocumentScanningDTO } from "./api/rpc/document-scanning.dto";
import { EmployeeLocationsDTO, GetEmployeeLocationsParams } from "./api/rpc/employee-locations.dto";
import { GetTagsForEmployeeParams } from "./api/rpc/employee-tag.dto";
import { GetHolidaysDTO, VenueHolidaysDTO } from "./api/rpc/holiday.dto";
import { AbsenceDTO, AccountDTO, BalancesDTO, ContractDTO, CostCenterDTO, CreateApprovedAbsenceParams, DailyResultsDTO, DepartmentDTO, DocumentDTO, DocumentExportDTO, DocumentTagDTO, EmployeeDTO, EmployeePayrollDataDTO, EmployeeTagDTO, GetAllContractsParams, GetContractsParams, GetEmployeeIssuesParams, GetEmployeePayrollDataParams, GetJobPostingsParams, GetRevenueIssuesParams, GetRosterTemplatesParams, GetShiftIssuesParams, JobPostingDTO, JobPostingPublicDTO, LiveKitAuthTokenDTO, LoginThrottleStatusDTO, LoginThrottleStatusParams, NoteDTO, NotifyYnaEnabledParams, PositionDTO, PublishedRosterDTO, RequestFeatureAccessDTO, ResetLoginThrottleParams, RosterDailyResultsDTO, RosterNoteDTO, RosterTemplateDTO, SendOwnerWelcomeEmailDTO, SessionDTO, ShiftIssueDTO, TimeLogDeviceDTO, TimeLogEventDTO, TodaysEventsDTO, ToggleBetaCustomerParams, TransferVenueDTO, UpdateEmployeePayrollDataParams, VenueDTO, VenueStructureDTO, } from "./api/rpc/index";
import { AcceptJobApplicationDTO, RejectJobApplicationDTO, SaveJobApplicationNoteDTO, } from "./api/rpc/job-application.dto";
import { LoginWithGerlDTO } from "./api/rpc/login.dto";
import { GetReplacementCandidatesParams, GetReplacementCandidatesResponse } from "./api/rpc/replacement-candidates.dto";
import { ReportConversationDTO } from "./api/rpc/report-conversation.dto";
import { GetRosterCostsParams, RosterCostsDTO } from "./api/rpc/roster-costs.dto";
import { RosterTargetAnalysisDTO } from "./api/rpc/roster-target-analysis.dto";
import { safeAssign } from "./api/rpc/safe-assign";
import { GetLicenseSeatStateDTO, LicenseSeatStateDTO, UpdateLicenseSeatStateDTO } from "./api/rpc/seat.dto";
import { CreateShiftDTO, DeleteShiftDTO, GetShiftsDTO, ShiftDTO, ShiftResultDTO, UpdateShiftDTO, } from "./api/rpc/shift.dto";
import { TermsAndConditionsStateDTO, VoiceControlAiConditionsStateDTO } from "./api/rpc/terms.dto";
import { GetWorkingTimeForDepartmentsDTO, GetWorkingTimeForEmployeeDTO, GetWorkingTimeForVenuesDTO, WorkingTimeForDepartmentsDTO, WorkingTimeForEmployeeDTO, WorkingTimeForVenuesDTO, } from "./api/rpc/time-reports.dto";
import { UploadWorkerDocumentDTO } from "./api/rpc/upload-worker-document.dto";
import { BillingMode } from "./billing/billing-mode";
import { Invoice } from "./invoice";
import { Absence, Availability, BenefitType, BonusType, CompanyEntity, CompanyLifeCycleEvent, Contract, Department, Employee, Form, Gender, JobPosting, RevenueEntry, RevenueGroup, RevenuePrediction, RevenueType, Role, RosterNote, RosterTargets, TimeEntry, TimeEntryType, TimeSettings, Venue, } from "./model";
class DTO {
    constructor(props) {
        if (props) {
            Object.assign(this, props);
        }
    }
}
/**
 * Decorator for defining request handler methods
 */
function Handler(input, output) {
    return (proto, method) => {
        if (!proto.handlerDefinitions) {
            proto.handlerDefinitions = [];
        }
        proto.handlerDefinitions.push({
            method,
            input,
            output,
        });
    };
}
export const MaxFileSize = 1024 * 1024 * 10;
export class UpdateAccountParams extends DTO {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "email", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "lastName", void 0);
export class LoginParams extends DTO {
}
export class UpdateBillingParams extends DTO {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "addressLine1", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "addressLine2", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "city", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "comments", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateBillingParams.prototype, "numberOfEmployees", void 0);
export class GetCompanyParams extends DTO {
}
export class UpdateCompanyParams extends DTO {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "address", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "city", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "email", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "features", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "partnerIntegrations", void 0);
__decorate([
    Type(() => UpdateBillingParams),
    __metadata("design:type", UpdateBillingParams)
], UpdateCompanyParams.prototype, "billing", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "comments", void 0);
__decorate([
    Type(() => CompanyLifeCycleEvent),
    __metadata("design:type", CompanyLifeCycleEvent)
], UpdateCompanyParams.prototype, "newLifeCycleEvent", void 0);
__decorate([
    Type(() => EmployeeTagDTO),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "employeeTags", void 0);
__decorate([
    Type(() => BonusType),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "bonusTypes", void 0);
__decorate([
    Type(() => BenefitType),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "benefitTypes", void 0);
export class CreateVenueParams extends DTO {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "address", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "city", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "state", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Object)
], CreateVenueParams.prototype, "venueNumber", void 0);
export class UpdateVenueParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], UpdateVenueParams.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "address", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "city", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "state", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Object)
], UpdateVenueParams.prototype, "venueNumber", void 0);
export class CreateCompanyParams extends DTO {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "name", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "country", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "address", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "city", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "phone", void 0);
__decorate([
    Type(() => CreateVenueParams),
    __metadata("design:type", CreateVenueParams)
], CreateCompanyParams.prototype, "venue", void 0);
__decorate([
    Type(() => String),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "billingMode", void 0);
export class CreateDepartmentParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], CreateDepartmentParams.prototype, "venue", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateDepartmentParams.prototype, "name", void 0);
export class UpdateDepartmentParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], UpdateDepartmentParams.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateDepartmentParams.prototype, "name", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateDepartmentParams.prototype, "order", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateDepartmentParams.prototype, "rosterOrder", void 0);
export class CreateEmployeeParams {
    constructor(vals) {
        this.firstName = "";
        this.lastName = "";
        this.title = "";
        this.callName = "";
        this.birthName = "";
        this.birthCity = "";
        this.birthCountry = "";
        this.nationality = "";
        this.taxId = "";
        this.socialSecurityNumber = "";
        this.notes = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.phone2 = "";
        this.avatar = "";
        this.timePin = "";
        // Mirrors the REST bounds (`^[1-9][0-9]{0,8}$`) so both write paths agree, and keeps the value
        // inside the int4 column it lands in
        this.staffNumber = null;
        this.autoMeal = 0;
        this.positions = [];
        Object.assign(this, vals);
    }
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "title", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "callName", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateEmployeeParams.prototype, "birthday", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "birthName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "birthCity", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "birthCountry", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "nationality", void 0);
__decorate([
    IsEnum(Gender),
    IsOptional(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "gender", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "taxId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "socialSecurityNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "notes", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "address", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "city", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "phone", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "phone2", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "avatar", void 0);
__decorate([
    IsString(),
    Matches(/^([0-9]{4})?$/, { message: "timePin must be a 4-digit numeric string" }),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "timePin", void 0);
__decorate([
    IsInt(),
    Min(1),
    Max(999_999_999),
    IsOptional(),
    __metadata("design:type", Object)
], CreateEmployeeParams.prototype, "staffNumber", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "autoMeal", void 0);
__decorate([
    IsInt({ each: true }),
    __metadata("design:type", Array)
], CreateEmployeeParams.prototype, "positions", void 0);
__decorate([
    ValidateNested(),
    Type(() => Contract),
    __metadata("design:type", Contract)
], CreateEmployeeParams.prototype, "contract", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], CreateEmployeeParams.prototype, "access", void 0);
__decorate([
    IsEnum(Role),
    IsOptional(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "role", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "initialHours", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "initialVacationDays", void 0);
__decorate([
    Type(() => EmployeeTagDTO),
    __metadata("design:type", Array)
], CreateEmployeeParams.prototype, "tags", void 0);
export class GetEmployeesParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Array)
], GetEmployeesParams.prototype, "filters", void 0);
export class UpdateEmployeeParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], UpdateEmployeeParams.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "callName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "birthName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "birthCity", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "birthCountry", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "nationality", void 0);
__decorate([
    IsEnum(Gender),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "gender", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "taxId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "socialSecurityNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "notes", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateEmployeeParams.prototype, "birthday", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "address", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "city", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "phone2", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "avatar", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Matches(/^([0-9]{4})?$/, { message: "timePin must be a 4-digit numeric string" }),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "timePin", void 0);
__decorate([
    IsInt(),
    Min(1),
    Max(999_999_999),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateEmployeeParams.prototype, "staffNumber", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateEmployeeParams.prototype, "autoMeal", void 0);
__decorate([
    IsInt({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateEmployeeParams.prototype, "positions", void 0);
__decorate([
    ValidateNested(),
    Type(() => Contract),
    __metadata("design:type", Contract)
], UpdateEmployeeParams.prototype, "contract", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateEmployeeParams.prototype, "deleteContract", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], UpdateEmployeeParams.prototype, "access", void 0);
__decorate([
    IsOptional(),
    IsEnum(Role),
    __metadata("design:type", Number)
], UpdateEmployeeParams.prototype, "role", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateEmployeeParams.prototype, "deleteDanglingEntries", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Array)
], UpdateEmployeeParams.prototype, "shiftTemplates", void 0);
__decorate([
    Type(() => EmployeeTagDTO),
    __metadata("design:type", Array)
], UpdateEmployeeParams.prototype, "tags", void 0);
export class UpdateEmployeesParams extends DTO {
}
export class DeleteEmployeeParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], DeleteEmployeeParams.prototype, "id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DeleteEmployeeParams.prototype, "deleteDanglingEntries", void 0);
export class GetTimeEntriesParams extends DTO {
}
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], GetTimeEntriesParams.prototype, "employee", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetTimeEntriesParams.prototype, "department", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetTimeEntriesParams.prototype, "venue", void 0);
__decorate([
    IsEnum(TimeEntryType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], GetTimeEntriesParams.prototype, "type", void 0);
export var UpdateTimeEntriesContext;
(function (UpdateTimeEntriesContext) {
    UpdateTimeEntriesContext["OfferSwap"] = "offer_swap";
    UpdateTimeEntriesContext["TakeUnassigned"] = "take_unassigned";
    UpdateTimeEntriesContext["TakeOffered"] = "take_offered";
})(UpdateTimeEntriesContext || (UpdateTimeEntriesContext = {}));
export class UpdateTimeEntriesParams extends DTO {
}
__decorate([
    Type(() => TimeEntry),
    __metadata("design:type", Array)
], UpdateTimeEntriesParams.prototype, "updated", void 0);
__decorate([
    Type(() => TimeEntry),
    __metadata("design:type", Array)
], UpdateTimeEntriesParams.prototype, "removed", void 0);
export class RestoreDeletedTimeEntriesParams extends DTO {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], RestoreDeletedTimeEntriesParams.prototype, "employeeId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], RestoreDeletedTimeEntriesParams.prototype, "from", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], RestoreDeletedTimeEntriesParams.prototype, "to", void 0);
export class RequestSetPasswordParams extends DTO {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestSetPasswordParams.prototype, "email", void 0);
export class SetPasswordParams extends DTO {
}
__decorate([
    IsNumber(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], SetPasswordParams.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SetPasswordParams.prototype, "password", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SetPasswordParams.prototype, "token", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SetPasswordParams.prototype, "oldPassword", void 0);
export class PublishRosterParams extends DTO {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PublishRosterParams.prototype, "venue", void 0);
export class GetPublishedRosterParams extends DTO {
}
export class SendMessageParams extends DTO {
}
export class IgnoreIssuesParams extends DTO {
}
export class GetRevenueEntriesCountParams extends DTO {
}
export class GetRevenueEntriesParams extends DTO {
}
__decorate([
    IsEnum(RevenueType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], GetRevenueEntriesParams.prototype, "type", void 0);
export class UpdateRevenueEntriesParams extends DTO {
}
__decorate([
    Type(() => RevenueEntry),
    __metadata("design:type", Array)
], UpdateRevenueEntriesParams.prototype, "updated", void 0);
__decorate([
    Type(() => RevenueEntry),
    __metadata("design:type", Array)
], UpdateRevenueEntriesParams.prototype, "removed", void 0);
export class GetRevenueGroupsParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], GetRevenueGroupsParams.prototype, "venue", void 0);
__decorate([
    IsEnum(RevenueType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], GetRevenueGroupsParams.prototype, "type", void 0);
export class UpdateRevenueGroupParams extends DTO {
}
__decorate([
    Type(() => RevenueGroup),
    __metadata("design:type", RevenueGroup)
], UpdateRevenueGroupParams.prototype, "group", void 0);
__decorate([
    Type(() => RevenueGroup),
    __metadata("design:type", RevenueGroup)
], UpdateRevenueGroupParams.prototype, "merge", void 0);
export class GetRevenuePredictionsParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], GetRevenuePredictionsParams.prototype, "venue", void 0);
export class UpdateRevenuePredictionsParams extends DTO {
}
__decorate([
    Type(() => RevenuePrediction),
    __metadata("design:type", Array)
], UpdateRevenuePredictionsParams.prototype, "updated", void 0);
__decorate([
    Type(() => RevenuePrediction),
    __metadata("design:type", Array)
], UpdateRevenuePredictionsParams.prototype, "removed", void 0);
export class UnlockRevenueEntriesParams extends DTO {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], UnlockRevenueEntriesParams.prototype, "companyId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], UnlockRevenueEntriesParams.prototype, "from", void 0);
export class CommitCashbookParams extends DTO {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], CommitCashbookParams.prototype, "venue", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CommitCashbookParams.prototype, "until", void 0);
export class ImportVenueParams extends DTO {
}
export class StartSetupPaymentParams extends DTO {
}
export class StartSetupPaymentResponse extends DTO {
}
export class GetRosterTargetsParams extends DTO {
}
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetRosterTargetsParams.prototype, "from", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetRosterTargetsParams.prototype, "to", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], GetRosterTargetsParams.prototype, "venue", void 0);
export class UpdateRosterTargetsParams extends DTO {
}
__decorate([
    Type(() => RosterTargets),
    __metadata("design:type", Array)
], UpdateRosterTargetsParams.prototype, "updated", void 0);
export class GetRosterTargetAnalysisParams extends DTO {
}
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetRosterTargetAnalysisParams.prototype, "from", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetRosterTargetAnalysisParams.prototype, "to", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], GetRosterTargetAnalysisParams.prototype, "venue", void 0);
__decorate([
    IsInt({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], GetRosterTargetAnalysisParams.prototype, "departments", void 0);
__decorate([
    IsIn(["department", "weekday", "week"]),
    IsOptional(),
    __metadata("design:type", String)
], GetRosterTargetAnalysisParams.prototype, "groupBy", void 0);
export class GetAbsencesParams extends DTO {
}
export class RequestAbsenceParams extends DTO {
}
export class UpdateAbsenceRequestParams extends DTO {
}
export class DeleteAbsenceRequestParams extends DTO {
}
export class CreateInvitesParams extends DTO {
}
export class GetInviteResponse extends DTO {
}
export class JoinCompanyParams extends DTO {
}
export class GetRosterNotesParams extends DTO {
}
export class GetPublicRosterUrlParams extends DTO {
}
export class GetPublicRosterUrlResponse extends DTO {
}
export class GetPublicRosterParams extends DTO {
}
export class GetAvailabilitiesParams extends DTO {
}
export class CreateOrUpdateDocumentParams extends DTO {
}
__decorate([
    Type(() => DocumentTagDTO),
    __metadata("design:type", Array)
], CreateOrUpdateDocumentParams.prototype, "tags", void 0);
__decorate([
    Type(() => Form),
    __metadata("design:type", Object)
], CreateOrUpdateDocumentParams.prototype, "form", void 0);
export class GetDocumentsParams extends DTO {
}
export class CreateOrUpdateJobPostingParams extends DTO {
}
export class CreateJobApplicationParams extends DTO {
}
export class SocialSecurityRegistrationParams extends DTO {
}
export class SocialSecurityRegistrationResponse extends DTO {
}
export class ExportCompanyParams extends DTO {
}
export class ImportCoreDataParams extends DTO {
}
export class ImportCoreDataResponse extends DTO {
}
export class ImportCompanyResponse extends DTO {
}
export class GetInvoicesParams extends DTO {
}
export class CompanyExport extends DTO {
}
__decorate([
    Type(() => CompanyEntity),
    __metadata("design:type", CompanyEntity)
], CompanyExport.prototype, "company", void 0);
__decorate([
    Type(() => TimeEntry),
    __metadata("design:type", Array)
], CompanyExport.prototype, "timeEntries", void 0);
__decorate([
    Type(() => RosterTargets),
    __metadata("design:type", Array)
], CompanyExport.prototype, "rosterTargets", void 0);
__decorate([
    Type(() => RosterNote),
    __metadata("design:type", Array)
], CompanyExport.prototype, "rosterNotes", void 0);
__decorate([
    Type(() => Absence),
    __metadata("design:type", Array)
], CompanyExport.prototype, "absences", void 0);
__decorate([
    Type(() => Availability),
    __metadata("design:type", Array)
], CompanyExport.prototype, "availabilities", void 0);
__decorate([
    Type(() => DocumentExportDTO),
    __metadata("design:type", Array)
], CompanyExport.prototype, "documents", void 0);
__decorate([
    Type(() => JobPosting),
    __metadata("design:type", Array)
], CompanyExport.prototype, "jobPostings", void 0);
__decorate([
    Type(() => RevenueGroup),
    __metadata("design:type", Array)
], CompanyExport.prototype, "revenueGroups", void 0);
__decorate([
    Type(() => RevenueEntry),
    __metadata("design:type", Array)
], CompanyExport.prototype, "revenueEntries", void 0);
export var ExportFormat;
(function (ExportFormat) {
    ExportFormat["PayrollReportDetailed"] = "payroll_report_detailed";
    ExportFormat["PayrollReportOverview"] = "payroll_report_overview";
    ExportFormat["PayrollDatevLodas"] = "payroll_datev_lodas";
    ExportFormat["PayrollDatevLG"] = "payroll_datev_lg";
    ExportFormat["PayrollAgenda"] = "payroll_agenda";
    ExportFormat["PayrollAgendaEmployeeCoreData"] = "payroll_agenda_employee_core_data";
    ExportFormat["PayrollAgendaCalendar"] = "payroll_agenda_calendar";
    ExportFormat["PayrollLexware"] = "payroll_lexware";
    ExportFormat["PayrollAddison"] = "payroll_addison";
    ExportFormat["PayrollLohnAG"] = "payroll_lohn_ag";
    ExportFormat["PayrollSage"] = "payroll_sage";
    ExportFormat["PayrollBMDWages"] = "payroll_bmd";
    ExportFormat["PayrollBMDAbsences"] = "payroll_bmd_absences";
    ExportFormat["TimeSheet"] = "time_sheet";
    ExportFormat["RosterExcel"] = "roster_excel";
    ExportFormat["OvertimeExcel"] = "balances_overtime_excel";
    ExportFormat["AverageWorkTimeExcel"] = "balances_average_work_time_excel";
    ExportFormat["BalancesTimeExcel"] = "balances_time_excel";
    ExportFormat["BalancesVacationExcel"] = "balances_vacation_excel";
    ExportFormat["BalancesBonusesExcel"] = "balances_bonuses_excel";
    ExportFormat["CashbookDatev"] = "cashbook_datev";
    ExportFormat["CashbookDatevOnline"] = "cashbook_datev_online";
    ExportFormat["CashbookLexware"] = "cashbook_lexware";
    ExportFormat["CashbookGeneric"] = "cashbook_generic";
    ExportFormat["CashbookPDF"] = "cashbook_pdf";
    ExportFormat["EmployeeDataPDF"] = "employee_data_pdf";
    ExportFormat["EmployeeDataCSV"] = "employee_data_csv";
    ExportFormat["EmployeeTableExcel"] = "employee_table_excel";
})(ExportFormat || (ExportFormat = {}));
export class ExportParams extends DTO {
}
__decorate([
    Type(() => DocumentTagDTO),
    __metadata("design:type", Array)
], ExportParams.prototype, "tags", void 0);
export class ExportResponse extends DTO {
}
export class CreateOrUpdateTimeLogDeviceParams extends DTO {
}
export class GetTimeLogEventsParams extends DTO {
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], GetTimeLogEventsParams.prototype, "fromTime", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], GetTimeLogEventsParams.prototype, "toTime", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], GetTimeLogEventsParams.prototype, "onlyWithComments", void 0);
export class GetBalancesParams extends DTO {
}
export class GetDailyResultsParams extends DTO {
}
export class GetCommonWorkDaysParams extends DTO {
}
export class ResetBalancesParams extends DTO {
}
export class GetTimeReportsParams extends DTO {
}
export class TimeReport extends DTO {
}
export class DeleteDraftInvoiceParams extends DTO {
}
export class SendInvoiceParams extends DTO {
}
export class DeletePaymentMethodParams extends DTO {
}
export class GetCostReportsParams extends DTO {
}
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetCostReportsParams.prototype, "from", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetCostReportsParams.prototype, "to", void 0);
export class CostReport extends DTO {
}
export class SavingsReport extends DTO {
}
export class GetSavingsReportsParams extends DTO {
}
export class GetWeatherPredictionsParams extends DTO {
}
export class GetSchoolHolidaysParams extends DTO {
}
/**
 * Transport-agnostic interface defining communication
 * between [[RpcClient]] and [[Server]] instances.
 */
export class API {
    updateAccount(_params) {
        throw "not implemented";
    }
    login(_params) {
        throw "not implemented";
    }
    loginWithGerl(_params) {
        throw "not implemented";
    }
    me() {
        throw "not implemented";
    }
    acceptTermsAndConditionsAndProcessingAgreement() {
        throw "not implemented";
    }
    acceptVoiceControlAiConditions() {
        throw "not implemented";
    }
    getVoiceControlAiConditionsState() {
        throw "not implemented";
    }
    getTermsAndConditionsState() {
        throw "not implemented";
    }
    getTodaysEvents() {
        throw "not implemented";
    }
    getCompany(_params) {
        throw "not implemented";
    }
    createCompany(_params) {
        throw "not implemented";
    }
    sendOwnerWelcomeEmail(_params) {
        throw "not implemented";
    }
    updateCompany(_params) {
        throw "not implemented";
    }
    toggleBetaCustomer(_params) {
        throw "not implemented";
    }
    getLoginThrottleStatus(_params) {
        throw "not implemented";
    }
    resetLoginThrottle(_params) {
        throw "not implemented";
    }
    notifyYnaEnabled(_params) {
        throw "not implemented";
    }
    deleteCompany(_id) {
        throw "not implemented";
    }
    listCompanies() {
        throw "not implemented";
    }
    listAPIClients() {
        throw "not implemented";
    }
    createAPIClient(_params) {
        throw "not implemented";
    }
    grantAPIClientAccess(_params) {
        throw "not implemented";
    }
    revokeAPIClientAccess(_params) {
        throw "not implemented";
    }
    selectCompany(_id) {
        throw "not implemented";
    }
    getCompanyStructure() {
        throw "not implemented";
    }
    getVenues() {
        throw "not implemented";
    }
    getDepartments() {
        throw "not implemented";
    }
    getPositions() {
        throw "not implemented";
    }
    getBonusTypes() {
        throw "not implemented";
    }
    getCostCenters() {
        throw "not implemented";
    }
    getRosterTemplates(_params) {
        throw "not implemented";
    }
    getBenefitTypes() {
        throw "not implemented";
    }
    getInvoices(_params) {
        throw "not implemented";
    }
    deleteDraftInvoice(_params) {
        throw "not implemented";
    }
    sendInvoice(_params) {
        throw "not implemented";
    }
    deletePaymentMethod(_params) {
        throw "not implemented";
    }
    revokeSession() {
        throw "not implemented";
    }
    requestSetPassword(_params) {
        throw "not implemented";
    }
    setPassword(_params) {
        throw "not implemented";
    }
    createVenue(_params) {
        throw "not implemented";
    }
    updateVenue(_params) {
        throw "not implemented";
    }
    transferVenue(_params) {
        throw "not implemented";
    }
    archiveVenue(_id) {
        throw "not implemented";
    }
    restoreVenue(_params) {
        throw "not implemented";
    }
    createDepartment(_params) {
        throw "not implemented";
    }
    updateDepartment(_params) {
        throw "not implemented";
    }
    archiveDepartment(_id) {
        throw "not implemented";
    }
    createEmployee(_params) {
        throw "not implemented";
    }
    getTagsForEmployee(_params) {
        throw "not implemented";
    }
    getEmployeeTagsForCompany() {
        throw "not implemented";
    }
    updateDocumentTagsForCompany(_params) {
        throw "not implemented";
    }
    getDocumentTagsForCompany() {
        throw "not implemented";
    }
    getEmployees(_params) {
        throw "not implemented";
    }
    createNewCurrentContract(_params) {
        throw "not implemented";
    }
    updateEmployee(_params) {
        throw "not implemented";
    }
    getEmployeePayrollData(_params) {
        throw "not implemented";
    }
    updateEmployeePayrollData(_params) {
        throw "not implemented";
    }
    updateEmployees(_params) {
        throw "not implemented";
    }
    deleteEmployee(_params) {
        throw "not implemented";
    }
    getEmployeeLocations(_params) {
        throw "not implemented";
    }
    getContracts(_params) {
        throw "not implemented";
    }
    getAllContracts(_params) {
        throw "not implemented";
    }
    getTimeEntries(_params) {
        throw "not implemented";
    }
    getShifts(_params) {
        throw "not implemented";
    }
    createShift(_params) {
        throw "not implemented";
    }
    updateShift(_params) {
        throw "not implemented";
    }
    deleteShift(_params) {
        throw "not implemented";
    }
    getRosterTimeEntries(_params) {
        throw "not implemented";
    }
    getRosterVenueEmployeeIds(_params) {
        throw "not implemented";
    }
    updateTimeEntries(_params) {
        throw "not implemented";
    }
    offerShiftForTrade(timeEntryId) {
        throw "not implemented";
    }
    takeShift(timeEntryId) {
        throw "not implemented";
    }
    restoreDeletedTimeEntries(_params) {
        throw "not implemented";
    }
    publishRoster(_params) {
        throw "not implemented";
    }
    getPublishedRoster(_params) {
        throw "not implemented";
    }
    sendMessage(_params) {
        throw "not implemented";
    }
    getPublicRosterUrl(_params) {
        throw "not implemented";
    }
    getShiftIssues(_params) {
        throw "not implemented";
    }
    getEmployeeIssues(_params) {
        throw "not implemented";
    }
    getRevenueIssues(_params) {
        throw "not implemented";
    }
    ignoreIssues(_params) {
        throw "not implemented";
    }
    getRevenueEntriesCount(_params) {
        throw "not implemented";
    }
    getRevenueEntries(_params) {
        throw "not implemented";
    }
    updateRevenueEntries(_params) {
        throw "not implemented";
    }
    unlockRevenueEntries(_params) {
        throw "not implemented";
    }
    commitCashbook(_params) {
        throw "not implemented";
    }
    getRevenueGroups(_params) {
        throw "not implemented";
    }
    updateRevenueGroup(_params) {
        throw "not implemented";
    }
    deleteRevenueGroup(_id) {
        throw "not implemented";
    }
    getRevenuePredictions(_params) {
        throw "not implemented";
    }
    updateRevenuePredictions(_params) {
        throw "not implemented";
    }
    getRosterTargets(_params) {
        throw "not implemented";
    }
    updateRosterTargets(_params) {
        throw "not implemented";
    }
    getRosterTargetAnalysis(_params) {
        throw "not implemented";
    }
    startSetupPayment(_params) {
        throw "not implemented";
    }
    importVenue(_params) {
        throw "not implemented";
    }
    createAbsence(_params) {
        throw "not implemented";
    }
    createApprovedAbsence(params) {
        throw "not implemented";
    }
    updateAbsence(_params) {
        throw "not implemented";
    }
    deleteAbsence(_params) {
        throw "not implemented";
    }
    getAbsences(_params) {
        throw "not implemented";
    }
    requestAbsence(_params) {
        throw "not implemented";
    }
    updateAbsenceRequest(_params) {
        throw "not implemented";
    }
    deleteAbsenceRequest(_params) {
        throw "not implemented";
    }
    getReplacementCandidates(_params) {
        throw "not implemented";
    }
    createInvites(_params) {
        throw "not implemented";
    }
    getInvite(_params) {
        throw "not implemented";
    }
    joinCompany(_params) {
        throw "not implemented";
    }
    createOrUpdateTimeSettings(_params) {
        throw "not implemented";
    }
    deleteTimeSettings(_id) {
        throw "not implemented";
    }
    createOrUpdateRosterNote(_params) {
        throw "not implemented";
    }
    deleteRosterNote(_id) {
        throw "not implemented";
    }
    getRosterNotes(_params) {
        throw "not implemented";
    }
    getAvailabilities(_params) {
        throw "not implemented";
    }
    createAvailability(_params) {
        throw "not implemented";
    }
    updateAvailability(_params) {
        throw "not implemented";
    }
    deleteAvailability(_params) {
        throw "not implemented";
    }
    createOrUpdateDocument(_params) {
        throw "not implemented";
    }
    getDocuments(_params) {
        throw "not implemented";
    }
    deleteDocument(_id) {
        throw "not implemented";
    }
    uploadWorkerDocument(_params) {
        throw "not implemented";
    }
    scanDocument(_params) {
        throw "not implemented";
    }
    createOrUpdateJobPosting(_params) {
        throw "not implemented";
    }
    getJobPostings(_params) {
        throw "not implemented";
    }
    getJobPosting(_uuid) {
        throw "not implemented";
    }
    archiveJobPosting(_id) {
        throw "not implemented";
    }
    reactivateJobPosting(_id) {
        throw "not implemented";
    }
    deleteJobPosting(_id) {
        throw "not implemented";
    }
    createJobApplication(_params) {
        throw "not implemented";
    }
    deleteJobApplication(_id) {
        throw "not implemented";
    }
    acceptJobApplication(params) {
        throw "not implemented";
    }
    rejectJobApplication(_params) {
        throw "not implemented";
    }
    saveJobApplicationNote(_params) {
        throw "not implemented";
    }
    socialSecurityRegistration(_params) {
        throw "not implemented";
    }
    exportCompany(_params) {
        throw "not implemented";
    }
    importCoreData(_params) {
        throw "not implemented";
    }
    importCompany(_params) {
        throw "not implemented";
    }
    export(_params) {
        throw "not implemented";
    }
    createOrUpdateTimeLogDevice(_params) {
        throw "not implemented";
    }
    getTimeLogDevices() {
        throw "not implemented";
    }
    deleteTimeLogDevice(_id) {
        throw "not implemented";
    }
    getTimeLogEvents(_params) {
        throw "not implemented";
    }
    getDailyResults(_params) {
        throw "not implemented";
    }
    getRosterDailyResults(_params) {
        throw "not implemented";
    }
    getCommonWorkDays(_params) {
        throw "not implemented";
    }
    getBalances(_params) {
        throw "not implemented";
    }
    getTimeBalances(_params) {
        throw "not implemented";
    }
    getVacationBalances(_params) {
        throw "not implemented";
    }
    getBonusesBalances(_params) {
        throw "not implemented";
    }
    resetBalances(_params) {
        throw "not implemented";
    }
    getTimeReports(_params) {
        throw "not implemented";
    }
    getWorkingTimeForVenues(_params) {
        throw "not implemented";
    }
    getCostStructure(_params) {
        throw "not implemented";
    }
    getCostsByVenue(_params) {
        throw "not implemented";
    }
    getCostsForEmployee(_params) {
        throw "not implemented";
    }
    getWorkingTimeForDepartments(_params) {
        throw "not implemented";
    }
    getWorkingTimeForEmployee(_params) {
        throw "not implemented";
    }
    getCostReports(_params) {
        throw "not implemented";
    }
    getRosterCosts(_params) {
        throw "not implemented";
    }
    getSavingsReports(_params) {
        throw "not implemented";
    }
    getNotificationSettings() {
        throw "not implemented";
    }
    updateNotificationSettings(_settings) {
        throw "not implemented";
    }
    getWeatherPredictions(_params) {
        throw "not implemented";
    }
    getSchoolHolidays(_params) {
        throw "not implemented";
    }
    getHolidays(_params) {
        throw "not implemented";
    }
    getLiveKitAuthToken() {
        throw "not implemented";
    }
    reportConversation(_params) {
        throw "not implemented";
    }
    getConversationUsage() {
        throw "not implemented";
    }
    requestFeatureAccess(_params) {
        throw "not implemented";
    }
    getLicenseSeatState(_params) {
        throw "not implemented";
    }
    updateLicenseSeatState(_params) {
        throw "not implemented";
    }
    getNote(_type) {
        throw "not implemented";
    }
    saveNote(_params) {
        throw "not implemented";
    }
}
__decorate([
    Handler(UpdateAccountParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateAccountParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAccount", null);
__decorate([
    Handler(LoginParams, SessionDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LoginParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "login", null);
__decorate([
    Handler(LoginWithGerlDTO, SessionDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LoginWithGerlDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "loginWithGerl", null);
__decorate([
    Handler(undefined, AccountDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "me", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "acceptTermsAndConditionsAndProcessingAgreement", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "acceptVoiceControlAiConditions", null);
__decorate([
    Handler(undefined, VoiceControlAiConditionsStateDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getVoiceControlAiConditionsState", null);
__decorate([
    Handler(undefined, TermsAndConditionsStateDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getTermsAndConditionsState", null);
__decorate([
    Handler(undefined, TodaysEventsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getTodaysEvents", null);
__decorate([
    Handler(GetCompanyParams, CompanyEntity),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCompany", null);
__decorate([
    Handler(CreateCompanyParams, CompanyEntity),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createCompany", null);
__decorate([
    Handler(SendOwnerWelcomeEmailDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SendOwnerWelcomeEmailDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "sendOwnerWelcomeEmail", null);
__decorate([
    Handler(UpdateCompanyParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateCompany", null);
__decorate([
    Handler(ToggleBetaCustomerParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ToggleBetaCustomerParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "toggleBetaCustomer", null);
__decorate([
    Handler(LoginThrottleStatusParams, LoginThrottleStatusDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LoginThrottleStatusParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getLoginThrottleStatus", null);
__decorate([
    Handler(ResetLoginThrottleParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ResetLoginThrottleParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "resetLoginThrottle", null);
__decorate([
    Handler(NotifyYnaEnabledParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [NotifyYnaEnabledParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "notifyYnaEnabled", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteCompany", null);
__decorate([
    Handler(undefined, CompanyEntity),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "listCompanies", null);
__decorate([
    Handler(undefined, APIClientDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "listAPIClients", null);
__decorate([
    Handler(CreateAPIClientDTO, CreatedAPIClientDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateAPIClientDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "createAPIClient", null);
__decorate([
    Handler(UpdateAPIClientAccessDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateAPIClientAccessDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "grantAPIClientAccess", null);
__decorate([
    Handler(UpdateAPIClientAccessDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateAPIClientAccessDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "revokeAPIClientAccess", null);
__decorate([
    Handler(Number, SessionDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "selectCompany", null);
__decorate([
    Handler(undefined, VenueStructureDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getCompanyStructure", null);
__decorate([
    Handler(undefined, VenueDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getVenues", null);
__decorate([
    Handler(undefined, DepartmentDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getDepartments", null);
__decorate([
    Handler(undefined, PositionDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getPositions", null);
__decorate([
    Handler(undefined, BonusTypeDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getBonusTypes", null);
__decorate([
    Handler(undefined, CostCenterDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getCostCenters", null);
__decorate([
    Handler(GetRosterTemplatesParams, RosterTemplateDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterTemplatesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterTemplates", null);
__decorate([
    Handler(undefined, BenefitTypeDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getBenefitTypes", null);
__decorate([
    Handler(GetInvoicesParams, Invoice),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetInvoicesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getInvoices", null);
__decorate([
    Handler(DeleteDraftInvoiceParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteDraftInvoiceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteDraftInvoice", null);
__decorate([
    Handler(SendInvoiceParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SendInvoiceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "sendInvoice", null);
__decorate([
    Handler(DeletePaymentMethodParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeletePaymentMethodParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deletePaymentMethod", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "revokeSession", null);
__decorate([
    Handler(RequestSetPasswordParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RequestSetPasswordParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "requestSetPassword", null);
__decorate([
    Handler(SetPasswordParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SetPasswordParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "setPassword", null);
__decorate([
    Handler(CreateVenueParams, Venue),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateVenueParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createVenue", null);
__decorate([
    Handler(UpdateVenueParams, Venue),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateVenueParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateVenue", null);
__decorate([
    Handler(TransferVenueDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [TransferVenueDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "transferVenue", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "archiveVenue", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "restoreVenue", null);
__decorate([
    Handler(CreateDepartmentParams, Department),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateDepartmentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createDepartment", null);
__decorate([
    Handler(UpdateDepartmentParams, Department),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateDepartmentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateDepartment", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "archiveDepartment", null);
__decorate([
    Handler(CreateEmployeeParams, Employee),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createEmployee", null);
__decorate([
    Handler(GetTagsForEmployeeParams, EmployeeTagDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTagsForEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTagsForEmployee", null);
__decorate([
    Handler(undefined, EmployeeTagDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployeeTagsForCompany", null);
__decorate([
    Handler(DocumentTagDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateDocumentTagsForCompany", null);
__decorate([
    Handler(undefined, DocumentTagDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getDocumentTagsForCompany", null);
__decorate([
    Handler(GetEmployeesParams, EmployeeDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetEmployeesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployees", null);
__decorate([
    Handler(CreateNewCurrentContractParams, ContractDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateNewCurrentContractParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createNewCurrentContract", null);
__decorate([
    Handler(UpdateEmployeeParams, Employee),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateEmployee", null);
__decorate([
    Handler(GetEmployeePayrollDataParams, EmployeePayrollDataDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetEmployeePayrollDataParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployeePayrollData", null);
__decorate([
    Handler(UpdateEmployeePayrollDataParams, EmployeePayrollDataDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateEmployeePayrollDataParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateEmployeePayrollData", null);
__decorate([
    Handler(UpdateEmployeesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateEmployeesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateEmployees", null);
__decorate([
    Handler(DeleteEmployeeParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteEmployee", null);
__decorate([
    Handler(GetEmployeeLocationsParams, EmployeeLocationsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetEmployeeLocationsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployeeLocations", null);
__decorate([
    Handler(GetContractsParams, ContractDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetContractsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getContracts", null);
__decorate([
    Handler(GetAllContractsParams, ContractDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetAllContractsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getAllContracts", null);
__decorate([
    Handler(GetTimeEntriesParams, TimeEntry),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeEntries", null);
__decorate([
    Handler(GetShiftsDTO, ShiftDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetShiftsDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getShifts", null);
__decorate([
    Handler(CreateShiftDTO, ShiftResultDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateShiftDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "createShift", null);
__decorate([
    Handler(UpdateShiftDTO, ShiftResultDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateShiftDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateShift", null);
__decorate([
    Handler(DeleteShiftDTO, ShiftResultDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteShiftDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteShift", null);
__decorate([
    Handler(GetTimeEntriesParams, TimeEntry),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterTimeEntries", null);
__decorate([
    Handler(GetTimeEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterVenueEmployeeIds", null);
__decorate([
    Handler(UpdateTimeEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateTimeEntries", null);
__decorate([
    Handler(String, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "offerShiftForTrade", null);
__decorate([
    Handler(String, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "takeShift", null);
__decorate([
    Handler(RestoreDeletedTimeEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RestoreDeletedTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "restoreDeletedTimeEntries", null);
__decorate([
    Handler(PublishRosterParams, Boolean),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PublishRosterParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "publishRoster", null);
__decorate([
    Handler(GetPublishedRosterParams, PublishedRosterDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetPublishedRosterParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getPublishedRoster", null);
__decorate([
    Handler(SendMessageParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SendMessageParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "sendMessage", null);
__decorate([
    Handler(GetPublicRosterUrlParams, GetPublicRosterUrlResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetPublicRosterUrlParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getPublicRosterUrl", null);
__decorate([
    Handler(GetShiftIssuesParams, (ShiftIssueDTO)),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetShiftIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getShiftIssues", null);
__decorate([
    Handler(GetEmployeeIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetEmployeeIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployeeIssues", null);
__decorate([
    Handler(GetRevenueIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueIssues", null);
__decorate([
    Handler(IgnoreIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [IgnoreIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "ignoreIssues", null);
__decorate([
    Handler(GetRevenueEntriesCountParams, (Promise)),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueEntriesCountParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueEntriesCount", null);
__decorate([
    Handler(GetRevenueEntriesParams, RevenueEntry),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueEntries", null);
__decorate([
    Handler(UpdateRevenueEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRevenueEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRevenueEntries", null);
__decorate([
    Handler(UnlockRevenueEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UnlockRevenueEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "unlockRevenueEntries", null);
__decorate([
    Handler(CommitCashbookParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CommitCashbookParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "commitCashbook", null);
__decorate([
    Handler(GetRevenueGroupsParams, RevenueGroup),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueGroupsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueGroups", null);
__decorate([
    Handler(UpdateRevenueGroupParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRevenueGroupParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRevenueGroup", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteRevenueGroup", null);
__decorate([
    Handler(GetRevenuePredictionsParams, RevenuePrediction),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenuePredictionsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenuePredictions", null);
__decorate([
    Handler(UpdateRevenuePredictionsParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRevenuePredictionsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRevenuePredictions", null);
__decorate([
    Handler(GetRosterTargetsParams, RosterTargets),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterTargetsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterTargets", null);
__decorate([
    Handler(UpdateRosterTargetsParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRosterTargetsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRosterTargets", null);
__decorate([
    Handler(GetRosterTargetAnalysisParams, RosterTargetAnalysisDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterTargetAnalysisParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterTargetAnalysis", null);
__decorate([
    Handler(StartSetupPaymentParams, StartSetupPaymentResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StartSetupPaymentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "startSetupPayment", null);
__decorate([
    Handler(ImportVenueParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ImportVenueParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "importVenue", null);
__decorate([
    Handler(Absence, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Absence]),
    __metadata("design:returntype", Promise)
], API.prototype, "createAbsence", null);
__decorate([
    Handler(CreateApprovedAbsenceParams, AbsenceDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateApprovedAbsenceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createApprovedAbsence", null);
__decorate([
    Handler(Absence, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Absence]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAbsence", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteAbsence", null);
__decorate([
    Handler(GetAbsencesParams, Absence),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetAbsencesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getAbsences", null);
__decorate([
    Handler(RequestAbsenceParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RequestAbsenceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "requestAbsence", null);
__decorate([
    Handler(UpdateAbsenceRequestParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateAbsenceRequestParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAbsenceRequest", null);
__decorate([
    Handler(DeleteAbsenceRequestParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteAbsenceRequestParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteAbsenceRequest", null);
__decorate([
    Handler(GetReplacementCandidatesParams, GetReplacementCandidatesResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetReplacementCandidatesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getReplacementCandidates", null);
__decorate([
    Handler(CreateInvitesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateInvitesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createInvites", null);
__decorate([
    Handler(String, GetInviteResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "getInvite", null);
__decorate([
    Handler(JoinCompanyParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [JoinCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "joinCompany", null);
__decorate([
    Handler(TimeSettings, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [TimeSettings]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateTimeSettings", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteTimeSettings", null);
__decorate([
    Handler(RosterNoteDTO, RosterNoteDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RosterNoteDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateRosterNote", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteRosterNote", null);
__decorate([
    Handler(GetRosterNotesParams, RosterNoteDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterNotesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterNotes", null);
__decorate([
    Handler(GetAvailabilitiesParams, Availability),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetAvailabilitiesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getAvailabilities", null);
__decorate([
    Handler(Availability, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Availability]),
    __metadata("design:returntype", Promise)
], API.prototype, "createAvailability", null);
__decorate([
    Handler(Availability, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Availability]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAvailability", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteAvailability", null);
__decorate([
    Handler(CreateOrUpdateDocumentParams, DocumentDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateOrUpdateDocumentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateDocument", null);
__decorate([
    Handler(GetDocumentsParams, DocumentDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetDocumentsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getDocuments", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteDocument", null);
__decorate([
    Handler(UploadWorkerDocumentDTO, DocumentDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UploadWorkerDocumentDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "uploadWorkerDocument", null);
__decorate([
    Handler(DocumentScanningDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DocumentScanningDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "scanDocument", null);
__decorate([
    Handler(CreateOrUpdateJobPostingParams, JobPostingDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateOrUpdateJobPostingParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateJobPosting", null);
__decorate([
    Handler(GetJobPostingsParams, JobPostingDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetJobPostingsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getJobPostings", null);
__decorate([
    Handler(String, JobPostingPublicDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "getJobPosting", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "archiveJobPosting", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "reactivateJobPosting", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteJobPosting", null);
__decorate([
    Handler(CreateJobApplicationParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateJobApplicationParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createJobApplication", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteJobApplication", null);
__decorate([
    Handler(AcceptJobApplicationDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AcceptJobApplicationDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "acceptJobApplication", null);
__decorate([
    Handler(RejectJobApplicationDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RejectJobApplicationDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "rejectJobApplication", null);
__decorate([
    Handler(SaveJobApplicationNoteDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SaveJobApplicationNoteDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "saveJobApplicationNote", null);
__decorate([
    Handler(SocialSecurityRegistrationParams, SocialSecurityRegistrationResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SocialSecurityRegistrationParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "socialSecurityRegistration", null);
__decorate([
    Handler(ExportCompanyParams, CompanyExport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ExportCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "exportCompany", null);
__decorate([
    Handler(ImportCoreDataParams, ImportCoreDataResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ImportCoreDataParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "importCoreData", null);
__decorate([
    Handler(CompanyExport, ImportCompanyResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CompanyExport]),
    __metadata("design:returntype", Promise)
], API.prototype, "importCompany", null);
__decorate([
    Handler(ExportParams, ExportResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ExportParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "export", null);
__decorate([
    Handler(CreateOrUpdateTimeLogDeviceParams, TimeLogDeviceDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateOrUpdateTimeLogDeviceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateTimeLogDevice", null);
__decorate([
    Handler(undefined, TimeLogDeviceDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeLogDevices", null);
__decorate([
    Handler(String, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteTimeLogDevice", null);
__decorate([
    Handler(GetTimeLogEventsParams, TimeLogEventDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeLogEventsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeLogEvents", null);
__decorate([
    Handler(GetDailyResultsParams, DailyResultsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetDailyResultsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getDailyResults", null);
__decorate([
    Handler(GetDailyResultsParams, RosterDailyResultsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetDailyResultsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterDailyResults", null);
__decorate([
    Handler(GetCommonWorkDaysParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCommonWorkDaysParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCommonWorkDays", null);
__decorate([
    Handler(GetBalancesParams, BalancesDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getBalances", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeBalances", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getVacationBalances", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getBonusesBalances", null);
__decorate([
    Handler(ResetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ResetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "resetBalances", null);
__decorate([
    Handler(GetTimeReportsParams, TimeReport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeReportsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeReports", null);
__decorate([
    Handler(GetWorkingTimeForVenuesDTO, WorkingTimeForVenuesDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetWorkingTimeForVenuesDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getWorkingTimeForVenues", null);
__decorate([
    Handler(GetCostStructureDTO, CostStructureDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCostStructureDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCostStructure", null);
__decorate([
    Handler(GetCostsByVenueDTO, CostsByVenueDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCostsByVenueDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCostsByVenue", null);
__decorate([
    Handler(GetCostsForEmployeeDTO, CostsForEmployeeDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCostsForEmployeeDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCostsForEmployee", null);
__decorate([
    Handler(GetWorkingTimeForDepartmentsDTO, WorkingTimeForDepartmentsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetWorkingTimeForDepartmentsDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getWorkingTimeForDepartments", null);
__decorate([
    Handler(GetWorkingTimeForEmployeeDTO, WorkingTimeForEmployeeDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetWorkingTimeForEmployeeDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getWorkingTimeForEmployee", null);
__decorate([
    Handler(GetTimeReportsParams, TimeReport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCostReportsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCostReports", null);
__decorate([
    Handler(GetRosterCostsParams, RosterCostsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterCostsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterCosts", null);
__decorate([
    Handler(GetSavingsReportsParams, SavingsReport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetSavingsReportsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getSavingsReports", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getNotificationSettings", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateNotificationSettings", null);
__decorate([
    Handler(GetWeatherPredictionsParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetWeatherPredictionsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getWeatherPredictions", null);
__decorate([
    Handler(GetSchoolHolidaysParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetSchoolHolidaysParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getSchoolHolidays", null);
__decorate([
    Handler(GetHolidaysDTO, VenueHolidaysDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetHolidaysDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getHolidays", null);
__decorate([
    Handler(undefined, LiveKitAuthTokenDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getLiveKitAuthToken", null);
__decorate([
    Handler(undefined, ReportConversationDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ReportConversationDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "reportConversation", null);
__decorate([
    Handler(undefined, ConversationUsageDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getConversationUsage", null);
__decorate([
    Handler(RequestFeatureAccessDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RequestFeatureAccessDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "requestFeatureAccess", null);
__decorate([
    Handler(GetLicenseSeatStateDTO, LicenseSeatStateDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetLicenseSeatStateDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "getLicenseSeatState", null);
__decorate([
    Handler(UpdateLicenseSeatStateDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateLicenseSeatStateDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateLicenseSeatState", null);
__decorate([
    Handler(String, NoteDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "getNote", null);
__decorate([
    Handler(NoteDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [NoteDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "saveNote", null);
//# sourceMappingURL=api.js.map